import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// Bootstrap's modal plugin announces `show.bs.modal` through jQuery's trigger(), which never
// reaches a data-action - bind it in connect()/disconnect() instead (see P22).
const JQUERY_NAMESPACE = ".catalogs"
const ENTER_KEY = 13

export default class extends Controller {
  static get targets() { return ["modal"]; }

  connect() {
    $(this.modalTarget).on(`show.bs.modal${JQUERY_NAMESPACE}`, this.onModalShow.bind(this))
  }

  disconnect() {
    $(this.modalTarget).off(JQUERY_NAMESPACE)
  }

  onModalShow(event) {
    const button = event.relatedTarget // Button/link that triggered the modal.
    this.retrieveVariant(button.dataset.url)
  }

  addProduct(event) {
    const url = event.target.closest("a").dataset.url
    this.swapWithResponseFrom(RequestHelper.defaultPostOptions(), url)
  }

  removeProduct(event) {
    const url = event.target.closest("a").dataset.url
    this.swapWithResponseFrom(RequestHelper.defaultDeleteOptions(), url)
  }

  changeVariant(event) {
    event.preventDefault()
    this.retrieveVariant(event.currentTarget.dataset.path)
  }

  changeProductImage(event) {
    event.preventDefault()
    this.retrieveVariant(event.currentTarget.dataset.path)
  }

  changeProductImageOnEnter(event) {
    if (event.which !== ENTER_KEY) { return; }

    this.changeProductImage(event)
  }

  // The response is this controller's own element re-rendered (categories, product grid and all)
  // - the controller replaces its own element and Stimulus reconnects the replacement, along with
  // whatever is nested inside it, for free.
  //
  // S1-innerhtml: server-rendered HTML from our own origin - Catalogs::CatalogsProductsController
  // #create/#destroy both `render "catalogs/show", layout: false`. That template (and the
  // catalogs/_products and unties/_categories partials it includes) uses no `raw`/`html_safe`/`!=`;
  // product name/summary go through ProductDecorator#summary, which calls the real Rails
  // `sanitize` via ProductsHelper#sanitized_html.
  swapWithResponseFrom(options, url) {
    fetch(url, options).
      then(response => {
        if (!response.ok) { throw new Error(`Catalog update failed (${response.status})`); }
        return response.text();
      }).
      then(html => { this.element.outerHTML = html; }).
      catch(this.logFailedCall)
  }

  // S1-innerhtml: server-rendered HTML from our own origin - catalogs/products/show.html.haml,
  // rendered by Catalogs::ProductsController#show (image chevrons) and
  // Catalogs::Products::VariantsController#show (variant swap). No `raw`/`html_safe`/`!=` in that
  // template; @product.name/@variant.name are auto-escaped and @product.description runs through
  // ProductDecorator#description, which calls the real Rails `sanitize` via
  // ProductsHelper#sanitized_html before simple_format re-sanitizes it.
  retrieveVariant(url) {
    fetch(url, RequestHelper.defaultRequestOptions()).
      then(response => {
        if (!response.ok) { throw new Error(`Product lookup failed (${response.status})`); }
        return response.text();
      }).
      then(html => {
        this.modalTarget.querySelector(".modal-dialog .modal-content").outerHTML = html;
      }).
      catch(this.logFailedCall)
  }

  logFailedCall(response) {
    console.warn(response)
  }
}
